import $ from 'jquery';
import './Pagination';

$('.search-toggle').on('click', function (e){
    e.preventDefault();
    $.magnificPopup.open({
        items: {
            src: '#search-popup'
        },
        type: 'inline',
        callbacks: {
            open: function() {
                setTimeout(function() {
                    $('.mfp-content').find('.search-popup__input').focus();
                }, 50);
            },
        }
    });
})

$('.main-content .tx-indexedsearch').each(function () {
    sessionStorage.removeItem('pagination-'+ $(this).closest('.frame').attr('id'));
    new Pagination($(this), '.tx-indexedsearch-res', 12)
})


var $mainSearch = $('.main-content #tx-indexedsearch-searchbox-sword');
var $heroSearch = $('.hero__searchbox');

if($mainSearch.length > 0 && $heroSearch.length > 0) {
    $heroSearch.val($mainSearch.val());
}
